export default function PreviousButton({ pagination, loading, handlePageChange }) {
    return (
        <button
            onClick={() =>
                handlePageChange(pagination.current_page - 1)
            }
            disabled={
                loading || pagination.current_page === 1
            }
        >
            Previous
        </button>
    );
}
